module.exports = __webpack_public_path__ + "static/img/avatar.cf9f1a81.png";